import React from "react";
import "./career.css";
import building from "../Assets/hairun.jpg";
import officeDesign from "../Assets/logia.jpg";
import training from "../Assets/stage.jpg";
import { FormattedMessage } from "react-intl";

const Career = () => {
  return (
    <section id="career" className="career-wrapper">
      <div className="container career-content">
        <h1 className="title">
          <FormattedMessage id="career.title" defaultMessage="Where I've worked." />
        </h1>
        <div>
          <div className="career-item wow fadeInLeft">
            <img src={training} alt="Training" />
            <div className="career-info">
              <h2>2019</h2>
              <h3 className="text-yellow-with-line">AUXIMAD Madagascar</h3>
              <p><FormattedMessage id="career.stagedev" defaultMessage="Intern web and mobil developer."/></p>
            </div>
          </div>
          <div className="career-item wow fadeIn">
            <div className="career-info">
              <h2>2020</h2>
              <h3 className="text-yellow-with-line">Logia Studio Madagascar</h3>
              <p><FormattedMessage id="career.devfull" defaultMessage="Fullstack developer."/></p>
            </div>
            <img src={officeDesign} alt="Office Design" />
          </div>
          <div className="career-item wow fadeInRight">
            <img src={building} alt="Building" />
            <div className="career-info">
              <h2>2021</h2>
              <h3 className="text-yellow-with-line">Hairun Technology</h3>
              <p><FormattedMessage id="career.integr" defaultMessage="Web integrator / Front End developer." /></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Career;
